export const HEADLESS_OPTIONS_LIMIT = 1000

// Guardrail against an unexpectedly large list freezing the browser, not a feature.
// A list that can legitimately exceed this belongs behind a search endpoint.
export function renderHeadlessSafeItems<T>(items: T[]): T[] {
  return items.slice(0, HEADLESS_OPTIONS_LIMIT)
}

export function isHeadlessOptionsTruncated<T>(items: T[]): boolean {
  return items.length > HEADLESS_OPTIONS_LIMIT
}
